import { Component, EventEmitter, Output, ViewEncapsulation, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CorrectiveActionTemplateService, TemplateRequest, CorrectiveActionTemplate } from '../../core/services/corrective-action-template.service';
import { SessionService } from '../../core/session.service';

@Component({
  selector: 'app-action-template-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './action-template-modal.component.html',
  styleUrls: ['./action-template-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class ActionTemplateModalComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    document.body.classList.add('modal-open');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
  }

  @Output() close = new EventEmitter<void>();
  @Output() created = new EventEmitter<CorrectiveActionTemplate>();

  private fb = inject(FormBuilder);
  private templateService = inject(CorrectiveActionTemplateService);
  private session = inject(SessionService);
  private translate = inject(TranslateService);

  loading = false;
  errorMsg = '';

  form = this.fb.nonNullable.group({
    name: ['', Validators.required],
    description: ['', Validators.required],
  });

  submit(): void {
    if (this.loading || this.form.invalid) return;

    this.loading = true;
    this.errorMsg = '';

    const raw = this.form.getRawValue();
    const payload: TemplateRequest = {
      title: raw.name.trim(),
      name: raw.name.trim(),
      description: raw.description.trim(),
      category: 'general',
      priority: 'medium',
      estimated_duration: 1,
      steps: [],
      triggerReason: 'Action corrective'
    };

    this.templateService.createTemplate(payload).subscribe({
      next: (response) => {
        // Simulate TemplateResponse since API returns {template_id}
        const template: CorrectiveActionTemplate = {
          id: response.template_id || response.id,
          title: payload.title,
          name: payload.name,
          description: payload.description,
          category: payload.category,
          priority: payload.priority,
          estimated_duration: payload.estimated_duration,
          steps: payload.steps
        };
        this.created.emit(template);
        this.close.emit();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        // Essayer différentes structures possibles pour le message d'erreur
        this.errorMsg = err?.error?.message ||
                       err?.error ||
                       err?.message ||
                       (typeof err?.error === 'string' ? err.error : null) ||
                       this.translate.instant('componentsWizard.actionTemplate.errorDefault');
      },
    });
  }

  onClose(): void {
    if (!this.loading) this.close.emit();
  }
}
